<template>
  <regular-bar :config="config">
    <div class="button" @click="showPanel('delete')">
      <v-icon>mdi-delete</v-icon>
      <v-dialog v-model="showDialog.delete" max-width="500">
        <v-card>
          <v-card-title class="headline error" primary-title="primary-title">
            <h4 class="white--text">{{ $t('deleteAccessories.title') }}</h4>
          </v-card-title>
          <div class="card-content pl-5 pr-5 mb-10">
            <div class="text-center pt-10 pb-10">
              <v-icon color="error" size="50">mdi-alert</v-icon>
            </div>
            <p class="text-center font-weight-medium is-size-5" v-html="warningOfDelete"></p>
          </div>
          <v-card-actions>
            <v-row>
              <v-spacer></v-spacer>
              <v-col cols="auto">
                <v-btn class="mr-5" @click="cancel('delete')" color="error" outlined="outlined" min-width="180">{{ $t('buttons.cancel') }}</v-btn>
                <v-btn @click="deleteItem" color="error" min-width="180">{{ $t('buttons.confirm') }}</v-btn>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div class="button" @click="showPanel('create')">
      <v-icon>mdi-plus</v-icon>
      <v-dialog v-model="showDialog.create" max-width="500">
        <v-card>
          <v-card-title class="headline primary" primary-title="primary-title">
            <h4 class="white--text">{{ $t('addAccessories.title') }}</h4>
          </v-card-title>
          <div class="card-content pl-5 pr-5 mb-10">
            <create-accessories :data="form" @update="updateForm"></create-accessories>
          </div>
          <v-card-actions>
            <v-row>
              <v-spacer></v-spacer>
              <v-col cols="auto">
                <v-btn class="mr-5" @click="cancel('create')" color="error" outlined="outlined" min-width="180">{{ $t('buttons.cancel') }}</v-btn>
                <v-btn @click="addItem" color="primary" min-width="180">{{ $t('buttons.add') }}</v-btn>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </regular-bar>
</template>

<script>
import RegularBar from './Regular'
import CreateAccessories from '@/components/Maintenance/Forms/CreateAccessories'

export default {
  components: { RegularBar, CreateAccessories },
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      showDialog: {
        delete: false,
        create: false
      },
      form: {
        store: '',
        name: '',
        amount: null
      }
    }
  },
  computed: {
    warningOfDelete () {
      return this.$t('deleteAccessories.question')
    },
    editPage () {
      return this.$route.path + '/edit'
    }
  },
  methods: {
    showPanel (type) {
      this.showDialog[type] = true
    },
    deleteItem () {
      // do action
      this.showDialog.delete = false
    },
    addItem () {
      this.showDialog.create = false
    },
    cancel (type) {
      this.showDialog[type] = false
    },
    updateForm ({ field, value }) {
      this.form[field] = value
    }
  }
}
</script>
